<template>
  <div class="app">
    <div v-for="(item, index) in list" class="news-card" :key="index" @click="goDetail(item)">
      <img v-if="item.tp" :src="item.tp.split(',')" class="img" />
      <div class="card-right">
        <span class="title"> {{ item.bt }}</span>
        <span class="time">{{ item.createTime }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      },
    },
    // 自定义返回逻辑
    clickItem: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      listData: [],
    }
  },
  watch: {
    list: {
      immediate: true,
      handler() {
        this.listData = this.list
      },
    },
  },
  created() {},
  methods: {
    goDetail: function (e) {
     this.$emit('click',e)
    },
  },
}
</script>

<style lang="less">
.news-card {
  height: auto;
  background: #ffffff;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  padding: 12px 10px;
  position: relative;

  .img {
    width: 64px;
    height: 64px;
    margin-right: 10px;
  }

  .card-right {
    flex: 1;
    display: flex;
    flex-direction: column;
    .title {
      color: #333333;
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 10px;
    }
    .time {
      font-size: 13px;
      font-weight: 400;
      color: #999999;
      margin-top: 10px;
    }
  }

  .dz {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
  }
}

.jiaobiao {
  width: 80px;
  height: 80px;
  background: #99adc2;
  color: #fff;
  display: flex;
  align-items: flex-end;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  position: absolute;
  font-size: 12px;
  top: -48px;
  right: -48px;
  justify-content: center;
}
.jiaobiao font {
  position: relative;
  top: 2px;
  letter-spacing: 1px;
}
</style>
